import { IHooksUseRequestAddIncognitoToUserParams } from '@/interfaces';
import { useMutation } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { useInvalidateQueries } from '@/hooks';
import { broadcastService } from '@/services';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

type TParams = {
  disableInvalidateQueries?: boolean;
};
type TDataVariables = IHooksUseRequestAddIncognitoToUserParams;
type TResponseData = void;

export const useRequestAddIncognitoToUser = (params?: TParams) => {

  const { invalidate } = useInvalidateQueries();
  const { isPending, error, mutateAsync } = useMutation({
    mutationKey: [routes.api.users.base, 'addIncognito'],
    mutationFn: ({ userId, ...data }: TDataVariables) =>
      apiClient
        .put<TResponseData>(routes.api.users.addIncognito(userId), data)
        .then(handleApiResponse)
        .then(() => broadcastService.events.publish({ type: 'userCoinsEdited', data: ({ userId, ...data }) })),
    onSuccess: () => (
      !params?.disableInvalidateQueries &&
      Promise
        .all([
          invalidate(routes.api.subAccounts),
          invalidate(routes.api.searchUser),
          invalidate(routes.api.users.base)
        ])
    )
  });

  const triggerAddIncognitoToUser = (data: TDataVariables) =>
    mutateAsync(data);

  return ({
    isLoadingAddIncognitoToUser: isPending,
    triggerAddIncognitoToUser,
    error
  });

};
